import { GetCollaboratorsHistoryProjectsResponse } from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import {
  AddCollaboratorsProjects,
  UpdateCollaboratorsProjectsRequest,
} from "../../../types/api/projects.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryProjectsService = {
  async list(
    collaboratorId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsHistoryProjectsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";
    const response =
      await httpClient.get<GetCollaboratorsHistoryProjectsResponse>(
        `v1/collaborators/${collaboratorId}/history/projects?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
  async add(
    collaboratorId: number,
    body: AddCollaboratorsProjects,
  ): Promise<void> {
    await httpClient.post(
      `v1/collaborators/${collaboratorId}/history/projects`,
      body,
    );
  },
  async update(
    collaboratorId: number,
    projectId: number,
    body: UpdateCollaboratorsProjectsRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/projects/${projectId}`,
      body,
    );
  },
  async delete(collaboratorId: number, projectId: string): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/projects/${projectId}`,
    );
  },
};

export default CollaboratorsHistoryProjectsService;
